import { useQuery } from "@tanstack/react-query"
import { workflowsQuery } from "../lib/workflowsQuery"

export function useWorkflowsQuery(campaignId?: string) {
  return useQuery(workflowsQuery(campaignId))
}
